import axios from 'axios'
import { getApiUrls } from "@/http/base.http";

export function getServiceStatus(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}remoteops/service/status`, payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}

export function serviceStart(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}remoteops/service/start`, payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}

export function serviceStop(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}remoteops/service/stop`, payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function serviceReset(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}remoteops/service/reset`, payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function serviceRestart(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}remoteops/controller/restart`, payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}

export function getResetPassword(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}remoteops/controller/password/change`, payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}

export function getRemoteServiceDetails(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}remoteops/service/detail`, payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}